// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Control } from '../Control';
import HotkeysSettingsContainerTemplate from '@front/templates/HotkeysSettingsContainerTemplate.html';
import { HotkeysManager } from '@shared/commons/cache/Hotkeys/HotkeysManager';
import { PanelNames } from '../../UtilsClasses/FactoryConstants';
import { HotkeysGroupTrading } from '@shared/commons/cache/Hotkeys/NamesEventHotkey ';
import { Resources } from '@shared/localizations/Resources';
import { HotkeysEditControlEvents } from './HotkeysEditControl';
import { CustomEvent } from '@shared/utils/CustomEvents';
export class HotkeysSettingsContainer extends Control {
    constructor() {
        super();
        this.HotkeyValueChanged = new CustomEvent();
        const map = HotkeysManager.GetHotkeysMap();
        const groupItems = [];
        for (const key of map.keys()) {
            const group = new HotkeyGroup(this.getNameGroup(key), map.get(key));
            groupItems.push(group);
        }
        void this.set({ groupItems });
    }
    oncomplete() {
        super.oncomplete();
        this.on(HotkeysEditControlEvents.ValueChanged, this.valueChangedEvent);
    }
    getNameGroup(key) {
        switch (key) {
            case PanelNames.ChartPanel:
                return Resources.getResource('panel.chart');
            case PanelNames.MarketDepthPanel:
                return Resources.getResource('panel.level2');
            case PanelNames.AdvancedOrderEntry:
                return Resources.getResource('panel.orderEntry');
            case HotkeysGroupTrading:
                return Resources.getResource('property.Trading');
            case PanelNames.OrdersPanel:
                return Resources.getResource('panel.orders');
            case PanelNames.InformerPanel:
                return Resources.getResource('panel.informer');
        }
    }
    valueChangedEvent(context, item, value) {
        this.HotkeyValueChanged.Raise(this, item, value);
    }
}
Control.extendWith(HotkeysSettingsContainer, {
    template: HotkeysSettingsContainerTemplate,
    data: function () {
        return {
            groupItems: []
        };
    }
});
export class HotkeyGroup {
    constructor(groupName, groupItems) {
        this.GroupName = '';
        this.GroupItems = [];
        this.GroupName = groupName;
        this.GroupItems = groupItems;
    }
}
